import axiosWithAuth from '../utils/axiosWithAuth';

/**
 * Get all styles for calculation
 * @returns {Promise<Object>} - The styles data
 */
export const getStylesForCalculation = async () => {
  try {
    const api = axiosWithAuth();
    const response = await api.get('/repair-styles');
    return response.data;
  } catch (error) {
    console.error('Error fetching styles for calculation:', error);
    throw error;
  }
};

/**
 * Get style details by ID
 * @param {string} styleId - The ID of the style to fetch
 * @returns {Promise<Object>} - The style data
 */
export const getStyleById = async (styleId) => {
  try {
    const api = axiosWithAuth();
    const response = await api.get(`/repair-styles/${styleId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching style details:', error);
    throw error;
  }
};

const stylesService = {
  getStylesForCalculation,
  getStyleById
};

export default stylesService; 